import styled from 'styled-components';

export default styled.div`
  .checkbox-radio-disabled-color .Mui-disabled {
    color: darkgray;
  }
`;
